import { useState } from 'react';
import { Field } from 'formik';
import { Stack, Text, VStack, Box } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const AppAuthMaxAccessFailuresField = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!(errors.maxAccessFailures && touched.maxAccessFailures)
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Max Access Failures
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Maximum number of access failures allowed.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NumberField}
                            name="maxAccessFailures"
                            id="maxAccessFailures"
                            placeholder="Enter max access failures"
                            min={0}
                            width="100%"
                            customWidth="100%"
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Set the maximum number of access failures before action is taken"
                        ariaLabel="max-access-failures-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AppAuthMaxAccessFailuresField;
